import {AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE} from './constants';

let url = location.href;
let chunks = url.replace(location.origin + '/', '').split('/');
let locale = chunks[0];

if (!(locale && AVAILABLE_LANGUAGES.includes(locale))) {
  location.href = location.origin + '/' + DEFAULT_LANGUAGE;
}

export default locale;


// WEBPACK FOOTER //
// ./src/lang/locale.js